const icons = {
    "SYSOFFICE" : "fas fa-briefcase",
    "SYSMEDICAL" : "fas fa-file-medical",
    "NOTICE" : "fas fa-bullhorn",
    "ATTEND" : "far fa-calendar-check",
    "DISC" : "fas fa-gavel",

    "pdf" : "file-pdf",
		"image" : "file-image",
		"text" : "file-text",
		"application": "file",

    "REPORT-TYPE-A" : "bullhorn",
    "REPORT-TYPE-D" : "inbox",
    "REPORT-TYPE-E" : "calendar-week",
    "REPORT-TYPE-F" : "paperclip",
    "REPORT-TYPE-G" : "spell-check",
    "REPORT-TYPE-L" : "link",
    "REPORT-TYPE-O" : "folder",
    "REPORT-TYPE-O-open" : "folder-open",
    "REPORT-TYPE-P" : "scroll",
    "REPORT-TYPE-T" : "comments",
    "REPORT-TYPE-I" : "cog"
};

function iconClass( code ) {
    return icons[ code ];
}

export default iconClass;